import React from "react";
import "./App.css";
import LoginComponent from "./component/Login/LoginComponent";
import PersonnelComponent from "./component/Personnel/PersonnelComponnet";
import PersonnelComponentNormal from "./component/Personnel/PersonnelComponentNormal";
import DepartmentComponent from "./component/Department/DepartmentComponent";
import DepStatisticsComponent from "./component/DepStatistics/DepStatisticsComponent";
import AbsenteeismComponent from "./component/Absenteeism/AbsenteeismComponent";
import DepStaDetailsComponent from "./component/DepStaDetails/DepStaDetailsComponent";
import ManageDepComponent from "./component/ManageDepartment/ManageDepComponent";
import ManageEmpComponent from "./component/ManageEmployee/ManageEmpComponent";
import AttendanceByNameComponent from "./component/AttendanceByName/AttendanceByNameComponent";
import AttendanceMonthlyComponent from "./component/AttendanceMonthly/AttendanceMonthlyComponent";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
// import UserComponent from './component/User/UserComponent';

function App() {
  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/Personnel" element={<PersonnelComponent />} />
            <Route path="/PersonnelNormal" element={<PersonnelComponentNormal />} />
            <Route path="/Department" element={<DepartmentComponent />} />
            <Route path="/AttendanceByName" element={<AttendanceByNameComponent />} />
            <Route path="/AttendanceMonthly" element={<AttendanceMonthlyComponent />} />
            <Route path="/Absenteeism" element={<AbsenteeismComponent />} />
            <Route
              path="/Department_Statistics"
              element={<DepStatisticsComponent />}
            />
            <Route
              path="/Department_Statistics_Details"
              element={<DepStaDetailsComponent />}
            />
            <Route path="/ManageDepartment" element={<ManageDepComponent />} />
            <Route path="/ManageEmployee" element={<ManageEmpComponent />} />
            {/* <Route path="/User_Management" element={<UserComponent/>} /> */}
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
